<template>
  <div class="company-crm-widget" v-if="site_token != null && crm_token != null">
    <iframe class="iframe-window" :src="$store.state.crm_url +
      'crm/' +
      site_token +
      '/' +
      crm_token +
      '/' +
      '?' +
      query_path
      " frameborder="0"></iframe>
    <div class="floater" v-show="show_chat">
      <chat :stranger="newChat"></chat>
    </div>
  </div>
  <div v-else class="loading-widget">
    <loading :height="25" color="#1ba5a4" :opacity="1" :width="25" :active.sync="is_loading" :is-full-page="false"
      :can-cancel="false" background-color="#ffffff" class="loader"></loading>
  </div>
</template>
<script>
import Chat from "@/components/Chat/Chat";
import { eventBus } from "../main";
export default {
  name: "company-profile",
  components: {
    Chat,
  },
  props: {},
  data: () => {
    return {
      is_loading: true,
      crm_token: null,
      site_token: null,
      newChat: null,
      show_chat: false,
      query_path: null,
    };
  },
  beforeCreate() { },
  mounted() {
    let vm = this;
    vm.$store
      .dispatch("GET_CRM_TOKEN", {
        id: vm.$getLoggedUser().id,
      })
      .then((responce) => {
        vm.site_token = sessionStorage.authToken;
        vm.crm_token = responce.data.access_token;
        if (vm.$route.query.path) {
          vm.query_path = new URLSearchParams(vm.$route.query).toString();
        } else {
          vm.query_path = "/school";
        }
      })
      .catch((error) => { });

    setInterval(() => {
      if (document.querySelector(".iframe-window")) {
        const frame = document.querySelector(".iframe-window");
        frame.contentWindow.postMessage(
          { message: "checkToHideChat", value: null },
          "*"
        );
      }
    }, 100);

    window.addEventListener("popstate", (event) => {
      setTimeout(() => {
        let path = vm.getQuery("path", document.location);
        if (document.querySelector(".iframe-window")) {
          const frame = document.querySelector(".iframe-window");
          history.back();
          frame.contentWindow.postMessage(
            { message: "crmPathNavigate", value: path },
            "*"
          );
        }
      }, 20);
    });
    window.addEventListener(
      "message",
      (event) => {
        const message = event.data.message;
        switch (message) {
          case "switchChat":
            vm.show_chat = event.data.value.data;
            break;
          case "parentNewTabNavigate":
            vm.crmNewTabNavigate(event.data.value);
            break;
          case "logoutUser":
            vm.logOut();
            break;
          case "crmNavigation":
            vm.crmNavigate(event.data.value);
            break;
          case "navigateTocompanySettings":
            vm.$router.push({ name: "companySettings" });
            break;
          case "routeNow":
            let route_link = vm.$router.resolve(event.data.value);
            window.open(route_link.href, "_blank");
            break;
          case "sendMessage":
            eventBus.$set(event.data.value, "id", event.data.value.copy);
            vm.newChat = event.data.value;
            break;
        }
      },
      false
    );

    setTimeout(() => {
      window.toggleNavigation();
    }, 3000);
  },
  computed: {},
  methods: {
    crmNewTabNavigate(url) {
      window.open(url, "_blank");
    },
    getQuery(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    crmNavigate(value) {
      let vm = this;
      vm.$router.push({ name: "crm", query: { path: value } });
    },
    logOut() {
      let vm = this;
      vm.$store.dispatch("AUTH_LOGOUT");
      vm.$cookies.remove("project-token");
      vm.$cookies.remove("employment-token");
      vm.$localStorage.remove("logged_user_data");
      vm.$router.push({ name: "login" });
    },
    switchTab(type) {
      let vm = this;
      vm.tab_type = type;
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.company-crm-widget {
  background: #fff;
  min-height: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 55px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 9999;

  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 45px;
  }

  .iframe-window {
    width: 100%;
    height: 100%;
  }
}

.loading-widget {
  background: #f7f7f7;
  min-height: 500px;
  width: 100%;
  padding-top: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
</style>